export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function chunkArray(items, chunkSize) {
  const separatedItems = [];

  for (let i = 0; i < items.length; i += chunkSize) {
    separatedItems.push(items.slice(i, i + chunkSize));
  }

  return separatedItems;
}
